import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonFloating from 'assets/components/button/themes/Theme.Button.Floating';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageList from 'assets/components/page/themes/Theme.Page.List';
import Pagination from 'assets/components/pagination/Pagination';
import ThemePaginationRounded from 'assets/components/pagination/themes/Theme.Pagination.Rounded';
import { getLocales } from 'assets/locales/Locale';
import { DataProvider } from 'assets/providers/data/DataProvider';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import { HttpStatus, managementHomeRoute } from 'config/Api.Config';
import { isMobile } from 'react-device-detect';
import { StatementBalanceEmailTemplateAction } from './StatementBalanceEmailTemplate.Hooks';
import useStatementBalanceEmailTemplate from './StatementBalanceEmailTemplate.Hooks';
import StatementBalanceEmailTemplateEdit from './sections/StatementBalanceEmailTemplate.Edit';
import StatementBalanceEmailTemplateDelete from './sections/StatementBalanceEmailTemplate.Delete';
import StatementBalanceEmailTemplateList from './sections/StatementBalanceEmailTemplate.List';
import StatementBalanceEmailTemplateFilters from './sections/StatementBalanceEmailTemplate.Filters';
import Box from 'assets/components/box/Box';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';

export const statementBalanceEmailTemplateIndexRoute =
  managementHomeRoute + '/statementBalanceEmailTemplate/:action?/:id?';
export default function StatementBalanceEmailTemplateIndex() {
  const { lang } = getLocales();
  const emailTemplateHook = useStatementBalanceEmailTemplate();

  if (!emailTemplateHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={emailTemplateHook}
        render={({ listApi, views, pageRouter, permissions }) => (
          <Page
            class={ThemePageList}
            isLoading={listApi.isExecuting}
            header={
              <>
                <h2 style={{ marginRight: 'auto' }} children={lang.emailTemplates} />
                <Box class={ThemeWrapperStack}>
                  {isMobile && <StatementBalanceEmailTemplateFilters />}
                  <Button
                    class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
                    active
                    media={<Icon class="fas-plus" />}
                    render={!isMobile && lang.addNew}
                    onClick={pageRouter.updateParams}
                    disabled={!permissions.CREATE_EMAILTEMPLATE}
                    data={{ action: StatementBalanceEmailTemplateAction.EDIT }}
                  />
                </Box>
              </>
            }
            subHeader={!isMobile && <StatementBalanceEmailTemplateFilters />}
            render={
              <>
                {views.edit && <StatementBalanceEmailTemplateEdit />}
                {views.delete && <StatementBalanceEmailTemplateDelete />}
                <StatementBalanceEmailTemplateList />
              </>
            }
            footer={
              <Pagination
                class={ThemePaginationRounded}
                count={listApi.payload?.count}
                offset={listApi.body?.offset}
                limit={listApi.body?.limit}
                onLimitChange={(limit) => listApi.execute((body) => ({ ...body, limit, offset: 0 }))}
                onOffsetChange={(offset) => listApi.execute((body) => ({ ...body, offset }))}
              />
            }
          />
        )}
      />
    </>
  );
}
